
import {finalize} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { SLEntity, SLEntityVersion } from './entity';
import { SLEntityService } from './entity.service';
import { NotifierService } from '../../ui';

@Component({
  templateUrl: './entity-version-list.component.html',
})
export class SLEntityVersionListComponent implements OnInit {

  entitiesCount: number = 0
  entities: SLEntityVersion[]

  entity: SLEntity

  constructor(
    private entityService: SLEntityService,
    private route: ActivatedRoute,
    private router: Router,
    private notifier: NotifierService,
  ) { }

  ngOnInit() {
    // Get the entity
    this.notifier.startProgress();

    this.route.data.subscribe((data) => {
      this.entity = data.entity;

      this.fetch();
    });

  }

  private fetch() {
    this.notifier.startProgress();

    this.entityService
      .entityVersions(this.entity.id).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        this.entities = result.reverse();
        this.entitiesCount = result.length;
      });
  }

  showSLEntityVersion(entity: SLEntityVersion, event: Event) {
    let nodeName = (<Element>event.target).nodeName;

    if (nodeName === 'TD' || nodeName === 'TR') {
      this.router.navigate(['shares-ledger', 'entities', entity.id, 'history', entity.version]);
    }
  }
}
